export default {
	'params': {
		'name': 'it',
		'code': 'it',
	},
	'errTitle': '404 Not Found',
	'needSomeHelpWithSymbol': 'Ti posso aiutare?',
	'getInTouch': 'Rimaniamo in contatto',
	'madeBy': 'Realizzato da',
	'home': 'Pagina principale',
	'aboutUs': 'Chi siamo',
	'products': 'Prodotti',
	'benefits': 'Benefici',
	'recipes': 'Ricette',
	'blog': 'Blog',
	'termsOfUse': 'Termini di utilizzo',
	'privacyPolicy': 'Informative sulla',
	'contactUs': 'Contattaci',
	'menu': 'Menu',
	'close': 'Chiudi',
	'en': 'En',
	'it': 'It',
	'zh': 'Zh',
	'faq': 'FAQ',
	'showMore': 'Mostra di più',
	'moreDetail': 'Ulteriori informazioni',
	'viewAll': 'Vedi tutti',
	'lastBlogs': 'Gli articoli più recenti del blog',
	'filterBy': 'Filtro',

	'byMeal': 'Per pasto',
	'byDietaryNeeds': 'In base alla dieta',
	'byIngredients': 'Per ingrediente',
	'difficulty': 'Difficoltà',
	'byProducts': 'Per tipo di prodotto',
	'recipesWith': 'Ricette con le diverse',
	'our': 'I Nostri',
	'apply': 'Scegli',
	'clearAll': 'Cancella tutto',
	'clearAllFilter': 'Cancella tutto',
	'noFilterData': 'Scusa, nessuna ricetta trovata',

	'orders': 'Ordine',
	'shipping': 'Spedizione',
	'marketing': 'Vendita',
	'product': 'Prodotto',

	'fullName': 'Nome e cognome',
	'email': 'Email',
	'message': 'Messaggio',
	'successText': 'Hooray! Your form has successfully zoomed into the digital universe!',
	'send': 'Spedisci',
	'selectSubject': 'Oggetto',
	'subject': 'Oggetto',

	'buyOnline': 'Acquista online',
	'composition': 'Composizione',
	'color': 'Colore',
	'foodPairings': 'Abbinamenti',
	'nosen': 'Profumi',

	'ingredients': 'Ingrediente',
	'servesWithSymbol': 'Ricetta per:',
	'watchHowTo': 'Guarda come',
	'make': 'fai',
	'shareWithSymbol': 'Condividi:',
	'learnMore': 'Scopri di più',
	'cookingWithOur': 'Cucinare con il nostro',
	'oliveOil': 'olio d’oliva',
	'allRecipes': 'Tutte le ricette',
	'craftedWith': 'Realizzato con',
	'ora': 'Ora',
	'oraBlend': 'varietà Ora',
	'ourProducts': 'I Nostri Prodotti',
	'opinion': 'di Noi',
	'peoples': 'Cosa Dicono',

	'404title': 'Pagina non trovata',
	'404description': 'C è qualcosa qui che non va molto bene. Non ti preoccupare, torna subito alla pagina principale',
	'goToHomepage': 'Torna alla pagina principale',

	'defaultError': 'Error',

	form: {
		validateMessages: {
			required: 'Per favore scrivi un {errorKey}.',
			email: 'Per favore scrivi un indirizzo email valido',
		},
	},

	'orderOutside': 'Se vuoi ordinare,',
};
